import {EMenuItemPosition} from '../../models/ui/menu-item.model';

export class MenuConstants {
    public static readonly MENU_COMPONENTS = {
        SUB_MENU: 'sub-menu',
        NOTIFICATIONS: 'notification-sub-menu',
    };

    public static readonly MENU_SECTIONS = {
        ASSETS: {
            NAME: '',
            MENU_ITEMS: {
                ASSETS: {
                    ROUTE: '/assets',
                    TITLE: 'Assets',
                    ICON: '/assets/images/menu/icon_sidemenu_assets_active.svg',
                    POSITION: EMenuItemPosition.TOP,
                    SUB_MENU_SECTIONS: []
                }
            }
        },
        PRODUCTS: {
            NAME: '',
            MENU_ITEMS: {
                PRODUCTS: {
                    ROUTE: '/products',
                    TITLE: 'Products',
                    ICON: '/assets/images/menu/icon_sidemenu_products_active.svg',
                    POSITION: EMenuItemPosition.TOP,
                    SUB_MENU_SECTIONS: []
                }
            }
        },
        MAIN: {
            NAME: '',
            MENU_ITEMS: {
                CAMPAIGNS: {
                    ROUTE: '/campaigns',
                    TITLE: 'Campaigns',
                    ICON: '/assets/images/menu/icon_sidemenu_campaigns_active.svg',
                    POSITION: EMenuItemPosition.TOP,
                    SUB_MENU_SECTIONS: [],
                }
            }
        },
        TEMPLATES: {
            NAME: 'templating',
            MENU_ITEMS: {
                TEMPLATES: {
                    ROUTE: '/templating/static-content-templates',
                    TITLE: 'Templating',
                    ICON: '/assets/images/menu/icon_sidemenu_templates_active.svg',
                    POSITION: EMenuItemPosition.TOP,
                    COMPONENT: MenuConstants.MENU_COMPONENTS.SUB_MENU,
                    SUB_MENU_SECTIONS: [
                        {
                            ITEMS: [
                                {
                                    ROUTE: '/templating/fonts',
                                    TITLE: 'Fonts'
                                }
                            ]
                        },
                        {
                            TITLE: 'Static content',
                        ITEMS: [
                            {
                                ROUTE: '/templating/static-content-templates',
                                TITLE: 'Templates'
                            },
                            {
                                ROUTE: '/templating/static-content-rulesets',
                                TITLE: 'Rulesets',
                            },
                            {
                                ROUTE: '/templating/design-libraries',
                                TITLE: 'Libraries',
                            },
                            {
                                ROUTE: '/templating/master-pages',
                                TITLE: 'Master pages',
                            }]
                        },
                        {
                            TITLE: 'Animated content',
                            ITEMS: [
                                {
                                    ROUTE: '/templating/animated-content-templates',
                                    TITLE: 'Templates'
                                },
                                {
                                    ROUTE: '/templating/animated-content-rulesets',
                                    TITLE: 'Rulesets'
                                },
                                {
                                    ROUTE: '/templating/after-effects-project-files',
                                    TITLE: 'After Effects project files'
                                }
                            ]
                        }
                    ]
                }
            }
        },
        WORKFLOWS: {
            NAME: 'workflows',
            MENU_ITEMS: {
                WORKFLOWS: {
                    ROUTE: '/workflows/configurations',
                    TITLE: 'Workflows',
                    ICON: '/assets/images/menu/icon_sidemenu_workflows_active.svg',
                    POSITION: EMenuItemPosition.TOP,
                    COMPONENT: MenuConstants.MENU_COMPONENTS.SUB_MENU,
                    SUB_MENU_SECTIONS: [{
                        ITEMS: [
                            {
                                ROUTE: '/workflows/workflow-automations',
                                TITLE: 'Workflow automations',
                            },
                            {
                                ROUTE: '/workflows/configurations',
                                TITLE: 'Configurations',
                            }
                        ]
                    }],
                },
            }
        },
        EXPORTS: {
            NAME: 'Export setups',
            MENU_ITEMS: {
                EXPORT_SETUPS: {
                    ROUTE: '/export-setups/campaign-package-setups',
                    TITLE: 'Export setups',
                    ICON: '/assets/images/menu/icon_sidemenu_export_setups_active.svg',
                    POSITION: EMenuItemPosition.TOP,
                    COMPONENT: MenuConstants.MENU_COMPONENTS.SUB_MENU,
                    SUB_MENU_SECTIONS: [{
                        ITEMS: [
                            {
                                ROUTE: '/export-setups/campaign-package-setups',
                                TITLE: 'Campaign package setups',
                            },
                            {
                                ROUTE: '/export-setups/product-asset-export-setups',
                                TITLE: 'Product asset export setups',
                            }
                        ]
                    }],
                },
            }
        },
        NOTIFICATIONS: {
            NAME: 'notifications',
            MENU_ITEMS: {
                NOTIFICATIONS: {
                    ROUTE: '',
                    TITLE: 'Notifications',
                    ICON: '/assets/images/menu/icon_sidemenu_notifications_active.svg',
                    POSITION: EMenuItemPosition.BOTTOM,
                    COMPONENT: MenuConstants.MENU_COMPONENTS.NOTIFICATIONS,
                    SUB_MENU_SECTIONS: []
                },
            }
        },
        SETTINGS: {
            NAME: 'settings',
            MENU_ITEMS: {
                SETTINGS: {
                    ROUTE: '/settings/user-management',
                    TITLE: 'Settings',
                    ICON: '/assets/images/menu/icon_sidemenu_settings_active.svg',
                    POSITION: EMenuItemPosition.BOTTOM,
                    COMPONENT: MenuConstants.MENU_COMPONENTS.SUB_MENU,
                    SUB_MENU_SECTIONS: [
                        {
                            TITLE: 'Users',
                            ITEMS: [
                                {
                                    ROUTE: '/settings/user-management',
                                    TITLE: 'User management',
                                },
                                {
                                    ROUTE: '/settings/role-management',
                                    TITLE: 'Role management',
                                },
                                {
                                    ROUTE: '/settings/audit-trail',
                                    TITLE: 'Audit Trail',
                                },
                                {
                                    ROUTE: '/settings/team-setup/general-information',
                                    TITLE: 'Team settings'
                                }
                            ]
                        },
                        {
                            TITLE: 'Data management',
                            ITEMS: [
                                {
                                    ROUTE: '/settings/briefing-data-management',
                                    TITLE: 'Briefing data'
                                },
                                {
                                    ROUTE: '/settings/product-data-management',
                                    TITLE: 'Product data'
                                },
                                {
                                    ROUTE: '/settings/asset-data-management',
                                    TITLE: 'Asset data'
                                },
                                {
                                    ROUTE: '/settings/variants',
                                    TITLE: 'Variants'
                                }
                            ]
                        },
                        {
                            TITLE: 'Content permissions',
                            ITEMS: [
                                {
                                    ROUTE: '/settings/content-rules',
                                    TITLE: 'Content rules',
                                },
                                {
                                    ROUTE: '/settings/content-groups',
                                    TITLE: 'Content groups',
                                }
                            ]
                        }
                    ]
                }
            }
        },
        ACCOUNT: {
            NAME: 'account-management',
            MENU_ITEMS: {
                ACCOUNT: {
                    ROUTE: '/my-account',
                    TITLE: 'Account',
                    ICON: '/assets/images/menu/icon_sidemenu_profile_active.svg',
                    POSITION: EMenuItemPosition.BOTTOM,
                    COMPONENT: MenuConstants.MENU_COMPONENTS.SUB_MENU,
                    SUB_MENU_SECTIONS: [{
                        ITEMS: [
                            {
                                ROUTE: '/my-account',
                                TITLE: 'My account',
                            },
                            {
                                ROUTE: '/dummy-route',
                                TITLE: 'Logout',
                                ACTION: 'logout'
                            }
                        ]
                    }]
                },
            }
        }
    };
}
